module.exports = __webpack_public_path__ + "img/power-icon.52dd892e.png";